module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_5.9e01274c.png";